<script lang="ts">
import { defineComponent } from 'vue';
import Notify from "~/widgets/Notify";
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'Form',
  data() {
    return {
      v$: useVuelidate({ $autoDirty: true }),
      watchValidationErrors: false as boolean,
    }
  },
  methods: {
    setErrorMessage(message: string): void {
      Notify.error(message);
    },

    setSuccessMessage(message: string): void {
      Notify.success(message);
    },

    showErrors() {
      Object.values(this.v$.$errors).forEach((error) => {
        Notify.error(error.$message);
      });
    },

    async submit(callback: Function) {
      const isValid = await this.v$.form.$validate();
      if (isValid) {
        await callback();
      } else {
        this.showErrors();
      }
    },
  },
  watch: {
    'v$.$errors'() {
      if (this.watchValidationErrors && this.v$.$errors.length) {
        this.showErrors();
      }
    },
  },
});
</script>
